<template>
  <div class="form-row">

    <Modal
      title="Your Event Photo"
      ref="croppieModal"
      @shown="croppieModalShown"
      large
    >

      <template v-slot:body>
        <div class="container-fluid">

          <div class="row">
            <p class="lead">Please adjust your photo so that the content you'd like to show in the app fits in the box below</p>
          </div>

          <div class="row">
            <div ref="croppie"></div>
          </div>

          <div class="row justify-content-center">

            <button id="ccw-rotate-btn" class="btn btn-info mr-4" @click.prevent="croppie.rotate(90)">
              <img src="../assets/images/rotate-ccw.png" class="rotate-btn-img"/>
            </button>

            <button id="cw-rotate-btn" class="btn btn-info ml-4" @click.prevent="croppie.rotate(-90)">
              <img src="../assets/images/rotate-cw.png" class="rotate-btn-img"/>
            </button>

          </div>

        </div>
      </template>

      <template v-slot:below-body>
        <div class="progress">
          <div class="progress-bar" :style="progressBar"></div>
        </div>
      </template>

      <template v-slot:footer>
        <button type="button" class="btn btn-primary" @click="croppiePicApproved">Looks Good</button>
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
      </template>

    </Modal>

    <div class="form-group d-sm-flex d-block">
      <div class="d-flex col-lg-2 col-md-3 col-sm-4 flex-column">
        <label>Photo</label>
        <div class="align-self-center">
          <label :class="`btn btn-outline-${invalid ? 'danger' : 'info'} mb-0 mr-1`">
            Choose Photo
            <input type="file" accept="image/*" @click="clearImgInput" @change="imgFileSelected" ref="imgInput" hidden>
          </label>
        </div>
      </div>

      <div class="d-flex col align-items-end mt-3">
        <small class="ml-3 bigger">
          You can upload a photo from your computer by selecting &quot;Upload File.&quot; Once
          an image is set, you can edit it by clicking on it below.
        </small>
      </div>
    </div>

    <div v-if="result" class="d-flex flex-column mx-auto mt-3 mb-4 w-100">
      <img :src="resultUrl" @click="showCroppieModal()" class="img-fluid img-thumbnail align-self-center w-75 pointer">
      <small class="text-center text-muted pt-2">
        If the result above looks unexpected, try clicking on it and then choosing &quot;Looks Good&quot; again
      </small>
    </div>

    <div v-show="invalid" class="invalid-feedback show ml-3 mb-4">
      Please select a photo for your event
    </div>

  </div>
</template>

<script>
import Croppie from 'croppie'
import Modal from '../components/Modal'

export default {
  components: {
    Modal: Modal
  },
  props: {
    value: {
      type: Blob,
      required: true
    },
    invalid: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      original: '',
      result: '',
      resultUrl: '',
      croppie: null,
      croppieState: {},
      croppieOpts: {
        enableOrientation: true,
        viewport: {
          width: 420,
          height: 238
        },
        boundary: {
          height: 300,
          width: 600
        }
      },

      // progressBar has been removed since we no longer update to firebase
      // from here, but we'll keep it in case we ever need it again
      progressBar: {
        width: '0%'
      }
    }
  },
  methods: {
    clearImgInput () {
      this.$refs.imgInput.value = null
    },
    imgFileSelected (e) {
      const fileArray = e.target.files
      if (fileArray.length > 0) {
        this.croppieState = {}
        URL.revokeObjectURL(this.original)
        this.original = URL.createObjectURL(fileArray[0])
        this.showCroppieModal()
      }
    },
    croppieModalShown () {
      this.croppie.bind()
    },
    showCroppieModal () {
      try {
        this.croppie.destroy()
      } catch {}
      this.croppie = new Croppie(this.$refs.croppie, this.croppieOpts)
      this.croppie.bind({
        url: this.original,
        ...this.croppieState
      })
        .then(this.show)
    },
    croppiePicApproved () {
      this.croppie.result({
        type: 'blob',
        size: { width: 800 }
      }).then(result => {
        this.croppieState = this.croppie.get()

        // This $emit allows a parent to use v-model on this component
        // (https://vuejs.org/v2/guide/components.html#Using-v-model-on-Components)
        this.$emit('input', result)
        this.result = result
        this.resultUrl = URL.createObjectURL(result)
        this.hide()
      })
    },
    show () {
      this.$refs.croppieModal.show()
    },
    hide () {
      this.$refs.croppieModal.hide()
    }
  },
  watch: {
    value (newVal) {
      if (!this.original) {
        this.result = newVal
        this.original = this.resultUrl = URL.createObjectURL(newVal)
      }
    },
    resultUrl (newVal, oldVal) {
      if (this.original !== oldVal) {
        URL.revokeObjectURL(oldVal)
      }
    }
  },
  beforeDestroy () {
    URL.revokeObjectURL(this.original)
    URL.revokeObjectURL(this.resultUrl)
  }
}
</script>

<style scoped>
@import "../assets/vendor/croppie/croppie.css";

.rotate-btn-img {
  height: 30px;
  width: 30px;
  filter: invert(100);
}

small.bigger {
  font-size: 90%;
}

.pointer {
  cursor: pointer;
}

.progress {
  height: 3px
}

.show {
  display: inherit;
}
</style>

<style>
.cr-boundary {
  max-width: 100%;
}
</style>
